import React from 'react';
import CartonMaterialsSection from 'components/quote_builder_widget/CartonMaterialsSection';
import { fieldGroupStyle, helpTextStyle, sectionHeaderStyle, toggleContainerStyle } from './sharedStyles';

const CartonMaterialsSectionWrapper = ({
  showCartonMaterials,
  setShowCartonMaterials,
  onMaterialsChange,
}) => {
  const dynamicToggleStyle = {
    ...toggleContainerStyle,
    backgroundColor: showCartonMaterials ? '#d4edda' : '#f8f9fa',
    border: showCartonMaterials ? '1px solid #c3e6cb' : '1px solid #dee2e6',
  };

  return (
    <div>
      <h4 style={sectionHeaderStyle}>
        {t('quote_builder_widget.section_carton_materials')}
      </h4>

      <div style={fieldGroupStyle}>
        <p style={helpTextStyle}>
          {t('quote_builder_widget.carton_materials_info') || 'Materials available in the widget for carton drawings'}
        </p>

        <div style={dynamicToggleStyle}>
          <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', margin: 0 }}>
            <input
              type="checkbox"
              checked={showCartonMaterials}
              onChange={(event) => setShowCartonMaterials(event.target.checked)}
              style={{ marginRight: '10px', width: '18px', height: '18px' }}
            />
            <span style={{ fontWeight: 500 }}>
              {showCartonMaterials
                ? (t('quote_builder_widget.carton_materials_enabled') || 'Carton materials are enabled')
                : (t('quote_builder_widget.carton_materials_disabled') || 'Carton materials are disabled')}
            </span>
          </label>
        </div>

        {showCartonMaterials && (
          <CartonMaterialsSection onMaterialsChange={onMaterialsChange} />
        )}
      </div>
    </div>
  );
};

export default CartonMaterialsSectionWrapper;
